import React from 'react';
import {useForm} from "../../shared/utils/forms/useForm";
import {UseFormSubmitModel} from "../../shared/utils/forms/models/UseFormModel";
import {FormElements} from "../../shared/ui/form/FormElements";
import {useAppDispatch} from "../../app/hooks";

import BtnPrimary from "../../shared/ui/button/primary/BtnPrimary";
import {addErrorMessage, addSuccessMessage, resetErrors} from "../../core/errors/errorSlice";
import {getAuth, signInWithEmailAndPassword} from 'firebase/auth';
import {app} from "../../firebaseConfig";


export function LoginForm({recoveryPswHandler}: { recoveryPswHandler: () => void }) {
    const dispatch = useAppDispatch();
    const auth = getAuth(app);
    const structureLoginData: any[] = [
        {
            type: 'input',
            name: "email",
            label: "Email",
            dataElement: {
                placeholder: "Inserisci la mail",
                type: 'text',
            },
            col: {xs: "12"},
        },
        {
            type: 'input',
            name: "password",
            label: "Password",
            dataElement: {
                placeholder: "Inserisci la password",
                type: 'password',
            },
            col: {xs: "12"},
        }
    ]

    const validationData = {
        email: {
            required: {
                params: {
                    name: "Email",
                },
            },
            email: {
                params: {
                    name: "Email",
                },
            },
        },
        password: {
            required: {
                params: {
                    name: "Password",
                },
            },
        },
    }

    const submitHandler: UseFormSubmitModel = (event, data) => {
        dispatch(resetErrors());
        signInWithEmailAndPassword(auth, dataForm.email, dataForm.password)
            .then(res => {
            }, err => {
                const errorMap: any = {
                    400: "Richiesta errata. Controlla i dati inseriti.",
                    401: "Autenticazione fallita. Controlla le tue credenziali.",
                    403: "Accesso vietato. Non hai i permessi necessari.",
                    404: "Risorsa non trovata. L'utente potrebbe non esistere.",
                    500: "Errore del server. Prova più tardi.",
                    503: "Servizio non disponibile. Riprova più tardi.",
                    default: "Si è verificato un errore imprevisto. Riprova più tardi."
                };
                const errorCode = err.code
                const errorMessage = errorMap[errorCode] || errorMap.default;
                dispatch(addErrorMessage({title: errorMessage}))
            })
    };

    const {
        isSubmit,
        errors,
        submitAction,
        changeValue,
        dataForm,
        setData
    } = useForm(submitHandler, validationData);

    return (

        <form className={"w-100"} onSubmit={submitAction}>
            <FormElements
                structure={structureLoginData}
                dataForm={dataForm}
                errors={errors}
                isSubmit={isSubmit}
                changeValue={changeValue}
            />
            <a href="#" onClick={recoveryPswHandler} className={'text-decoration-none'}>Ho dimenticato la password</a>

            <div className={'btn-row'}>
                <BtnPrimary className={'w-100'} type={'submit'}>Login</BtnPrimary>
            </div>

        </form>

    );
}
